// extracted by mini-css-extract-plugin
export default {"about":"about_about__ZjGt9","about__body":"about_about__body__rYUpf","about__subtitle":"about_about__subtitle__-VC4X","about__description":"about_about__description__bTZ2G"};